import { memo } from 'react';
import { useParams } from 'react-router';

import { ConsumerId as CopyConsumerId } from '@component/consumer-id/consumer-id';

export const ConsumerId = memo(() => {
  const { consumerId } = useParams();

  return <CopyConsumerId id={consumerId ?? ''} />;
});
